import { faker } from "@faker-js/faker";
import type { Meta, StoryObj } from "@storybook/react";

import { fakeBaseUserAvatarProps } from "@/__mocks__/mockBaseTypes";
import type { MessagesAvatarGroupProps } from "@/ui/core/MessagesAvatarGroup";
import MessagesAvatarGroup from "@/ui/core/MessagesAvatarGroup";

const mockAvatarUsers = faker.helpers.multiple(
  () => fakeBaseUserAvatarProps(),
  {
    count: { max: 10, min: 2 },
  },
);

const StoryMeta: Meta<MessagesAvatarGroupProps> = {
  title: "Core/Messages Avatar Group",
  component: MessagesAvatarGroup,
  argTypes: {
    users: { control: "object" },
  },
  args: {
    users: mockAvatarUsers,
  },
};

type Story = StoryObj<MessagesAvatarGroupProps>;

const Primary: Story = {};

const SingleUser: Story = {
  args: {
    users: [mockAvatarUsers[0]],
  },
};

const WithImages: Story = {
  args: {
    users: mockAvatarUsers.map((user) => ({
      ...user,
      imageUrl: "https://i.pravatar.cc/300",
    })),
  },
};

export { Primary, SingleUser, WithImages };
export default StoryMeta;
